import * as actionTypes from "../actionTypes";

export const getCategory = payload => ({
    type: actionTypes.GET_CATEGORY,
    payload
})

export const setCategory = payload => ({
    type: actionTypes.SET_CATEGORY,
    payload
})

export const createCategory = payload => ({
    type: actionTypes.CREATE_CATEGORY,
    payload
})

export const updateCategory = payload => ({
    type: actionTypes.UPDATE_CATEGORY,
    payload
})

export const deleteCategory = payload => ({
    type: actionTypes.DELETE_CATEGORY,
    payload
})

export const changeCategoryStatus = payload => ({
    type: actionTypes.CHANGE_CATEGORY_STATUS,
    payload
})

// export const getSubCategoryByCategoryId = payload => ({
//     type: actionTypes.GET_SUB_CATEGORY_BY_CATEGORY_ID,
//     payload
// })

// export const setSubCategoryByCategoryId = payload => ({
//     type: actionTypes.SET_SUB_CATEGORY_BY_CATEGORY_ID,
//     payload
// })

// export const getSubCategory = payload => ({
//     type: actionTypes.GET_SUB_CATEGORY,
//     payload
// })

// export const setSubCategory = payload => ({
//     type: actionTypes.SET_SUB_CATEGORY,
//     payload
// })

// export const createSubCategory = payload => ({
//     type: actionTypes.CREATE_SUB_CATEGORY,
//     payload
// })

// export const updateSubCategory = payload => ({
//     type: actionTypes.UPDATE_SUB_CATEGORY,
//     payload
// })

// export const deleteSubCategory = payload => ({
//     type: actionTypes.DELETE_SUB_CATEGORY,
//     payload
// })

// export const changesubCategoryStatus = payload => ({
//     type: actionTypes.CHANGE_SUB_CATEGORY_STATUS,
//     payload
// })

// export const getChildCategoryBySubCategoryId = payload => ({
//     type: actionTypes.GET_CHILD_CATEGORY_BY_SUB_CATEGORY_ID,
//     payload
// })

// export const setChildCategoryBySubCategoryId = payload => ({
//     type: actionTypes.SET_CHILD_CATEGORY_BY_SUB_CATEGORY_ID,
//     payload
// })

// export const getChildCategory = payload => ({
//     type: actionTypes.GET_CHILD_CATEGORY,
//     payload
// })

// export const setChildCategory = payload => ({
//     type: actionTypes.SET_CHILD_CATEGORY,
//     payload
// })

// export const createChildCategory = payload => ({
//     type: actionTypes.CREATE_CHILD_CATEGORY,
//     payload
// })

// export const updateChildCategory = payload => ({
//     type: actionTypes.UPDATE_CHILD_CATEGORY,
//     payload
// })

// export const deleteChildCategory = payload => ({
//     type: actionTypes.DELETE_CHILD_CATEGORY,
//     payload
// })

// export const changeChildCategoryStatus = payload => ({
//     type: actionTypes.CHANGE_CHILD_CATEGORY_STATUS,
//     payload
// })